import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useNavigation } from "../../utils/navigation";
import testImg from "../../assets/images/home/aboutus_test.webp";

const Container = styled.div`
  align-items: center;
  justify-content: center;
  @media (min-width: 765px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
`;
const Title = styled.h2`
  font-size: var(--font-size-xxlarge);
  color: var(--text-100);
  font-weight: 300;
`;
const Subtitle = styled.h4`
  font-size: var(--font-size-xlarge);
  color: var(--text-100);
  font-weight: 300;
  margin: 14px 0;
`;
const Text = styled.p`
  font-size: var(--font-size-small);
  @media (min-width: 765px) {
    font-size: var(--font-size-base);
  }
`;
const LogoDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  max-width: 100%;
  width: 100%;

  @media (max-width: 768px) {
    margin: 40px 0;
  }
`;

const Image = styled.img`
  max-width: 100%; /* Sprečava preklapanje slike */
  height: auto; /* Održava proporcije slike */
  object-fit: contain; /* Osigurava da slika stane bez izobličenja */

  /* Stilovi za mobilne uređaje */
  @media (max-width: 768px) {
    max-width: 200px; /* Manja maksimalna širina slike na mobilnim uređajima */
    width: 100%; /* Prilagođava širinu ekranu */
  }
`;

const CustomLink = styled(Link)`
  font-size: var(--font-size-base);
  text-transform: capitalize;
  font-weight: bold;
  color: var(--text-100);
`;

const AboutUsSection = () => {
  const { t } = useTranslation();
  const { goToCategory } = useNavigation();
  return (
    <Container>
      <LogoDiv>{/* <Image src={testImg} alt="Image" /> */}</LogoDiv>
      <div>
        <Title>{t("HOME.TITLE")}</Title>
        <Text>
          {t("HOME.INTRO_TEXT")}{" "}
          <CustomLink to={goToCategory("77")}>77</CustomLink>,{" "}
          <CustomLink to={goToCategory("velo")}>Velo</CustomLink>,{" "}
          <CustomLink to={goToCategory("zyn")}>Zyn</CustomLink>,{" "}
          <CustomLink to={goToCategory("skruf")}>Skruf</CustomLink>
        </Text>

        <Subtitle>{t("HOME.FAST_DELIVERY_TITLE")}</Subtitle>
        <Text>{t("HOME.FAST_DELIVERY_TEXT")}</Text>
      </div>
    </Container>
  );
};

export default AboutUsSection;
